export const scheduleJobLayoutStyles = {
  dialogPaper: {
    overflow: 'visible'
  },
  closeButton: {
    color: '#252e3d'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    paddingTop: 24,
    paddingBottom: 24,
    overflowY: 'visible'
  },
  jobCard: {
    backgroundColor: '#f1f5f9',
    borderRadius: 0,
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  jobCardName: {
    fontSize: 24,
    fontWeight: 400,
    color: '#252e3d',
    lineHeight: '32px'
  },
  jobCardAddress: {
    fontSize: 18,
    fontWeight: 400,
    color: '#738198',
    lineHeight: '28px'
  },
  jobCardMeta: {
    display: 'flex',
    alignItems: 'center',
    gap: 10
  },
  jobCardMetaText: {
    fontSize: 14,
    fontWeight: 400,
    color: '#929fb5',
    lineHeight: '20px'
  },
  jobCardMetaBullet: {
    fontSize: 14,
    color: '#d9dee8',
    lineHeight: '20px'
  }
} as const
